export const isSuccess = (
    thunkResponse: { type: string },
    asyncThunk: { fulfilled: { type: string } },
) => thunkResponse.type === asyncThunk.fulfilled.type;

export const isFailure = (
    thunkResponse: { type: string },
    asyncThunk: { rejected: { type: string } },
) => thunkResponse.type === asyncThunk.rejected.type;
